// Import Swiper and its modules
import Swiper from 'swiper';
import { Autoplay, EffectFade, Navigation } from 'swiper/modules';
import videoThumbDepoimento from '../modules/Utils/video_thumb_depoimento';
import simulationOneForm from '../modules/Utils/simulation_one_form';

simulationOneForm();
videoThumbDepoimento();

// DOM Elements
const creditTab = document.getElementById('creditTab');
const installmentTab = document.getElementById('installmentTab');
const rangeInput = document.getElementById('rangeInput');
const rangeValue = document.getElementById('rangeValue');
const rangeForm = document.getElementById('rangeForm');

// Format currency helper
const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(value);
};

// Navigation handlers
function handlePrevClick(swiper) {
    if (!swiper) {
        console.warn('Swiper is not initialized yet');
        return;
    }
    console.log('Previous button clicked');
    swiper.slidePrev();
    console.log('Current slide:', swiper.activeIndex);
}

function handleNextClick(swiper) {
    if (!swiper) {
        console.warn('Swiper is not initialized yet');
        return;
    }
    console.log('Next button clicked');
    swiper.slideNext();
    console.log('Current slide:', swiper.activeIndex);
}

// Form handlers
const handleTabClick = (tab) => {
    if (tab === 'credit') {
        creditTab.classList.add('active');
        installmentTab.classList.remove('active');
    } else {
        installmentTab.classList.add('active');
        creditTab.classList.remove('active');
    }
};

const handleRangeChange = (event) => {
    rangeValue.textContent = event.target.value;
};

const handleFormSubmit = (event) => {
    event.preventDefault();
    console.log('Form submitted with value:', rangeInput.value);
};

// Initialize Swiper
let swiperInstance = null;

document.addEventListener('DOMContentLoaded', () => {
    // Initialize banner Swiper only if element exists
    const bannerSliderEl = document.querySelector('.banner__slider');
    if (bannerSliderEl) {
        console.log('Initializing banner slider');

        swiperInstance = new Swiper('.banner__slider', {
            modules: [Autoplay, EffectFade, Navigation],
            slidesPerView: 'auto',
            spaceBetween: 0,
            loop: true,
            speed: 1000,
            autoplay: false,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                prevEl: '.banner__nav--prev',
                nextEl: '.banner__nav--next',
            },
            on: {
                init: (sw) => {
                    console.log('Swiper initialized successfully');
                },
                slideChange: () => {
                    console.log('Slide changed to:', swiperInstance?.activeIndex);
                }
            }
        });

        // Event listeners for Swiper navigation
        const prevButton = document.querySelector('.banner__nav--prev');
        const nextButton = document.querySelector('.banner__nav--next');

        if (swiperInstance && prevButton && nextButton) {
            prevButton.addEventListener('click', () => handlePrevClick(swiperInstance));
            nextButton.addEventListener('click', () => handleNextClick(swiperInstance));
        }
    }

    // Form event listeners (only if elements exist)
    if (creditTab && installmentTab) {
        creditTab.addEventListener('click', () => handleTabClick('credit'));
        installmentTab.addEventListener('click', () => handleTabClick('installment'));
    }

    if (rangeInput && rangeForm) {
        rangeInput.addEventListener('input', handleRangeChange);
        rangeForm.addEventListener('submit', handleFormSubmit);
    }

    // Custom slider initialization - only if element exists
    const customSliderEl = document.querySelector('.custom-slider');
    if (customSliderEl) {
        const slideCount = customSliderEl.querySelectorAll('.swiper-slide').length;
        console.log('Custom slider slide count:', slideCount);

        // Don't initialize if no slides (shouldn't happen with fallback, but safety check)
        if (slideCount === 0) {
            console.warn('No slides found in custom slider');
            return;
        }

        // Only enable loop if we have enough slides (at least 7 for 3.2 slidesPerView)
        const enableLoop = slideCount >= 7;

        const customSlider = new Swiper('.custom-slider', {
            modules: [Navigation, Autoplay],
            slidesPerView: 3,
            spaceBetween: 24,
            // loop: false,
            speed: 800,
            freeMode: false,
            // centeredSlides: true,
            // centeredSlidesBounds: true,
            autoplay: enableLoop ? {
                delay: 100000,
                disableOnInteraction: false,
            } : false,
            navigation: {
                prevEl: '.custom-slider__nav--prev',
                nextEl: '.custom-slider__nav--next',
            },
            breakpoints: {
                0: {
                    slidesPerView: 1.15,
                    spaceBetween: 16,
                    // centeredSlides: false,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                },
            },
            on: {
                init: function() {
                    console.log('Custom slider initialized successfully');
                },
                slideChange: function() {
                    console.log('Slide changed to:', this.activeIndex);
                }
            }
        });

        console.log('Custom slider initialized with loop:', enableLoop, 'slides:', slideCount);
    } else {
        console.warn('Custom slider element not found');
    }
});

// Video lightbox initialization
if (typeof GLightbox !== 'undefined') {
    var videoLightbox = GLightbox({
        selector: '.glightbox-unity',
        touchNavigation: true,
        loop: false,
        autoplayVideos: true
    });
}

// Unity Mobile Menu System


const mobileMenuToggleUnity = document.getElementById('mobile-menu-toggle-unity');
const navbarCollapseUnity = document.querySelector('.navbar-collapse-unity');
let burgerTimeline;




function initBurgerAnimation() {
    // Register GSAP plugin
    if (typeof gsap !== 'undefined' && gsap.registerPlugin) {
        gsap.registerPlugin(DrawSVGPlugin);

        // Create timeline with default settings
        burgerTimeline = gsap.timeline({
            defaults: { ease: "power2.inOut" },
            paused: true
        });

        // Set initial states
        gsap.set("#theBurger", { autoAlpha: 1 });
        gsap.set(".buns", { drawSVG: "0% 30%" });

        // Create animation sequence
        burgerTimeline.to(".patty", { duration: 0.35, drawSVG: "50% 50%" }, 0);
        burgerTimeline.to(".patty", { duration: 0.1, opacity: 0, ease: "none" }, 0.25);
        burgerTimeline.to(".buns", { duration: 0.85, drawSVG: "69% 96.5%" }, 0);
    }
}

function animateMenuIcon(isOpen) {
    if (burgerTimeline) {
        if (isOpen) {
            burgerTimeline.play();
        } else {
            burgerTimeline.reverse();
        }
    }
}

function toggleMobileMenuUnity() {
    const isOpen = navbarCollapseUnity.classList.contains('mobile-menu-open');

    if (isOpen) {
        // Close menu
        navbarCollapseUnity.classList.remove('mobile-menu-open');
        mobileMenuToggleUnity.classList.remove('menu-open');
        animateMenuIcon(false);
    } else {
        // Open menu
        navbarCollapseUnity.classList.add('mobile-menu-open');
        mobileMenuToggleUnity.classList.add('menu-open');
        animateMenuIcon(true);
        // Update position when opening menu
        updateMobileMenuPosition();
    }
}

function closeMobileMenu() {
    navbarCollapseUnity.classList.remove('mobile-menu-open');
    body.classList.remove('mobile-menu-active');
    mobileMenuToggleUnity.classList.remove('menu-open');
    animateMenuIcon(false);
}

    /*---------------------/ 3 - Events /-------------------*/

        // Mobile menu toggle
        if (mobileMenuToggleUnity) {
            mobileMenuToggleUnity.addEventListener('click', toggleMobileMenuUnity);
        }

        // Close menu when clicking on links
        const mobileNavLinks = navbarCollapseUnity.querySelectorAll('.nav-link:not(.dropdown-toggle)');
        mobileNavLinks.forEach(link => {
            link.addEventListener('click', closeMobileMenu);
        });


         // Initialize burger animation when DOM is ready
    document.addEventListener('DOMContentLoaded', () => {
        initBurgerAnimation();
    });


      // If DOM is already loaded, initialize immediately
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initBurgerAnimation);
    } else {
        initBurgerAnimation();
    }
